import { Spin } from "antd";
import { useMemo, useState } from "react";
import { useIntl } from "react-intl";

import { Image } from "~types/image";
import type { ImageTypes } from "~enums/imageTypes";
import { getImageQualityWarnings } from "./utilities";
import { WarningsTooltip } from "./components";

import "./ImageListView.scss";

type Props = {
  imageType: ImageTypes;
  image?: Image;
}

const ImageListView = ({ image, imageType }: Props) => {
  const [isImageLoading, setIsImageLoading] = useState<boolean>(!!image);
  const { formatMessage } = useIntl();
  const warnings = useMemo<string[]>(() => image ? getImageQualityWarnings(image, formatMessage) : [], [image]);
  const showWarnings = image && !isImageLoading && warnings.length > 0;

  return (
    <div className="image-list-view-image-container">
      {isImageLoading && <Spin size="default" className="spinner" />}
      {image && (
        <img
          alt={imageType}
          src={`${image.url}?size=100`}
          onLoad={() => setIsImageLoading(false)}
          onError={() => setIsImageLoading(false)}
        />
      )}
      {showWarnings && <WarningsTooltip warnings={warnings} className="warning-tooltip" />}
    </div>
  );
};

export default ImageListView;
